import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import connect from 'react-redux/es/connect/connect';
import {Card, Col, Layout, Row} from 'antd';
import './HomeScreen.css';
import ChangeCarScreen from './ChangeCarScreen';
import ActionnableCard from './ActionnableCard';
import ChangeDealerScreen from './ChangeDealerScreen';
import Storage from '../services/Storage';
import queryString from 'query-string';
import {isBigEnough} from './journey1/helper/uiHelper';
import LabeledText from '../components/common/text/LabeledText';
import moment from 'moment';
import {ItemSectionFragment} from './journey1/fragments/sectionFragment/itemSectionFragment';
import {DisplaySectionFragment} from './journey1/fragments/sectionFragment/displaySectionFragment';
import N_ServicesSectionFragment from './journey1/fragments/sectionFragment/N_ServicesSectionFragment';
import {SpinnerModal} from './components/SpinnerModal';
import {DAYS} from './journey1/definition/business';
import N_OfficialDocumentSectionFragment from './journey1/fragments/sectionFragment/N_OfficialDocumentSectionFragment';
import Alert from '../components/common/Alert';
import SAInfoBubble from '../components/common/confirmation/SAInfoBubble';
import StartJourneyButtons from "./StartJourneyButtons";
import Address from "../components/common/Address";
import ConsentForm from '../components/consent/ConsentForm';
import BrandUtil from '../services/BrandUtil';

const { Content } = Layout;

class HomeScreen extends Component {
  constructor(props) {
    super(props);
    const values = queryString.parse(this.props.location.search);
    const dealer = values.d;

    this.state = {
      fetchingVehicle: false,
    };
    Storage.setItem('dealer', dealer);
  }

  componentDidMount() {
    const params={};

    this.props.dispatchResetSteps();
    this.props.dispatchResetAppointmentRequest({
      plateNumber: (this.props.selectedVehicle && this.props.selectedVehicle.licensePlate) || null,
    });
    if (this.props.publicContext.bookingToken){
      params.bookingToken = this.props.publicContext.bookingToken;
    }
    this.props.dispatchFetchCustomerData(params);

    if (this.props.publicContext.dealer) {
      this.props.dispatchFetchMyDealer({ connectedId: this.props.publicContext.dealer });
    }
  }

  formatHours = hour => {
    const splitHours = hour.split(':');
    if (splitHours[1] === '00') return `${splitHours[0]}h`;
    return `${splitHours[0]}h${splitHours[1]}`;
  };

  formatHoursFromInterval = i =>
    `${this.formatHours(i.openTime)} - ${this.formatHours(i.closeTime)}`;

  renderOpeningHourForADay = (day, slots, formatMessage) => (
    <Row key={day}>
      <Col span={12}>{formatMessage({ id: `customer.home.${day.toLowerCase()}` })}</Col>
      <Col span={12}>
        <p>
          {slots === null
            ? formatMessage({ id: 'customer.home.closedDay' })
            : slots.map(this.formatHoursFromInterval).join(' ')}
        </p>
      </Col>
    </Row>
  );

  capabilitiesToArray = capabilities => {
    if (!capabilities) return [];
    const services247 = [];
    Object.keys(capabilities).forEach(key => {
      if (capabilities[key]) {
        services247.push(capabilities[key]);
      }
    });
    return services247;
  };

  render() {
    const {
      intl: { formatMessage },
      selectedVehicle,
      selectedDealer,
      dealerLoading,
      vehicleLoading,
      userData,
      userDataLoading,
      userDataError,
      customerPreJourneyInfoLoading,
      sizeClass,
      selectedVIN,
      publicContext,
      frontendConfig
    } = this.props;
    const brand = BrandUtil.resolveBrand().toLowerCase();
    const carFields = [];
    const dealerFields = [];
    const host = window.location.host.split('.').pop().toLowerCase();
    const locale = Storage.getItem('lg') || "en";
    let vehicle;
    let vehicleList;
    let dealer;
    let dealers;
    let appointment;
    let idData;
    let dealerOpeningHours;
    let overallServiceMapped;
    let capabilities;
    if (userData) {
      vehicle = userData.vehicle || selectedVehicle || selectedVIN;
      vehicleList = userData.vehicles;
      dealer = userData.dealer || selectedDealer;
      dealers = userData.dealers;
      appointment = userData.appointment;
      idData = userData.idData;
    }
    if (selectedVIN && !vehicle) {
      vehicle = selectedVIN;
    }

    if (selectedVehicle && !vehicle) {
      vehicle = selectedVehicle;
    }

    if (dealer) {
      dealerOpeningHours = dealer.openingHours.dealerOpeningHours;
      overallServiceMapped = dealer.overallServices.map(service => ({
        title: service,
      }));
      capabilities = this.capabilitiesToArray(dealer.capabilities);
    }

    const journey = appointment && appointment.journey ? appointment.journey : null;
    const properties = journey && journey.properties ? journey.properties : null;
    const reception = properties && properties.reception ? properties.reception : null;
    const dropOff = reception && reception.dropOff ? reception.dropOff : null;
    const mobility = properties && properties.mobility ? properties.mobility : null;
    const address = mobility && mobility.customerAddress ? mobility.customerAddress : null;
    const mobilityValue = mobility && mobility.mobility ? mobility.mobility.title : null;
    const services =
      properties && properties.services && properties.services.services
        ? properties.services.services
        : null;
    const tireExchange =
      properties && properties.services && properties.services.tiresExchange
        ? properties.services.tiresExchange
        : null;
    const tireReplacement =
      properties && properties.services && properties.services.tiresReplacement
        ? properties.services.tiresReplacement
        : null;
    let time = dropOff && dropOff.time ? dropOff.time : null;
    if (time) {
      const splittedTime = time.split(':');
      splittedTime.splice(2, 1);
      time = splittedTime.join(':');
    }
    let receptionText;
    if (dropOff && dropOff.driveIn) {
      receptionText = 'customer.journey.step.dateReception.driveInReception';
    } else if (dropOff && dropOff.fastlane) {
      receptionText = 'customer.journey.step.dateReception.fastlaneReception';
    } else if (dropOff && !dropOff.driveIn && !dropOff.fastlane) {
      receptionText = 'customer.journey.step.dateReception.standardReception';
    }

    if (vehicle) {
      carFields.push({ value: vehicle.brand, bold: true });
      carFields.push({ value: vehicle.model });
      carFields.push({
        name: formatMessage({ id: 'summary.vin' }),
        value: vehicle.vin,
      });
      carFields.push({ value: vehicle.licensePlate });
    }

    if (dealer) {
      dealerFields.push({value: dealer.dealerName, bold: true});
      dealerFields.push({value: `${dealer.address.street1}, ${dealer.address.city}, ${dealer.address.zipcode}, ${dealer.address.country}`});
    }

    return (
      <Layout className="layout">
        <SpinnerModal visible={userDataLoading || customerPreJourneyInfoLoading} />
        {!appointment && !userDataLoading && (
          <ChangeCarScreen vehicles={vehicleList} dealer={dealer} />
        )}
        {!appointment && dealers && dealers.length > 0 && (
          <ChangeDealerScreen dealers={dealers} vehicle={vehicle} />
        )}
        <Content style={{ margin: 'auto', paddingTop: '100px' }} className="homeContent">
          <Row gutter={16} style={{ marginBottom: 30 }}>
            <Col span={24} style={{ marginBottom: isBigEnough(sizeClass) ? 0 : 30 }}>
              <ActionnableCard
                contentCheck={vehicleList}
                fallbackMessage={formatMessage({id: 'customer.home.fetchCarFailed'})}
                sizeClass={sizeClass}
                loading={vehicleLoading}
                displayedObject={vehicle}
                action={this.props.openChangeCarModal}
                footerLabel={formatMessage({ id: 'customer.home.chooseCar' })}
                img={vehicle && vehicle.picture}
                imgAlt={vehicle && vehicle.picture && 'Car Picture'}
                fields={carFields}
                alternativeText={formatMessage({ id: 'customer.home.noSelectedVehicle' })}
                elements={vehicleList}
                displayFooter={!appointment && !publicContext.bookingToken}
                title={formatMessage({ id: 'customer.home.your-car' })}
              />
            </Col>
            {frontendConfig['one-login'] === true && <Col span={24}>
                <ConsentForm/>
            </Col>}
            <Col span={24}>
              <ActionnableCard
                contentCheck={!appointment ? dealers : true}
                fallbackMessage={formatMessage({id: 'customer.home.fetchDealerFailed'})}
                loading={dealerLoading}
                displayedObject={dealer}
                action={this.props.openChangeDealerModal}
                footerLabel={formatMessage({ id: 'customer.home.chooseDealer' })}
                alternativeText={formatMessage({ id: 'customer.home.noSelectedDealer' })}
                fields={dealerFields}
                elements={dealers}
                displayFooter={!appointment && !publicContext.dealer}
                title={formatMessage({ id: 'customer.home.your-dealer' })}
              >
                {dealer && (
                  <Row
                    style={{
                      width: '100%',
                      paddingLeft: 16,
                      borderTop: '3px solid rgb(212, 212, 212)',
                      paddingTop: 16,
                    }}
                  >
                    <Col span={10} xs={24} sm={24} md={24} lg={12} xl={10} xxl={10}>
                      <h3>Opening hours</h3>
                      <div style={{ marginLeft: 16 }}>
                        {DAYS.map(d =>
                          this.renderOpeningHourForADay(
                            d.toLowerCase(),
                            dealerOpeningHours[d.toUpperCase()]
                              ? dealerOpeningHours[d.toUpperCase()].slots
                              : null,
                            formatMessage
                          )
                        )}
                      </div>
                    </Col>
                    <Col span={10} xs={24} sm={24} md={24} lg={12} xl={10} xxl={10}>
                      <h3>Overall services</h3>
                      <div style={{ marginLeft: 16 }}>
                        {overallServiceMapped.map(s => (
                          <p key={s.title}>{s.title}</p>
                        ))}
                      </div>
                    </Col>
                    <Col span={10} xs={24} sm={24} md={24} lg={12} xl={10} xxl={10}>
                      <h3>24/7 Services</h3>
                      <div style={{ marginLeft: 16 }}>
                        {capabilities.map(s => (
                          <Row key={s.title}>
                            <Col span={20}>
                              <p key={s.title}>{s.title}</p>
                            </Col>
                            <Col span={4}>
                              <SAInfoBubble content={s.description} />
                            </Col>
                          </Row>
                        ))}
                      </div>
                    </Col>
                  </Row>
                )}
              </ActionnableCard>
            </Col>
          </Row>
          {!appointment &&
            vehicle &&
            selectedDealer &&
              <StartJourneyButtons sizeClass={sizeClass} />
          }

          {appointment && (
            <Card
              bordered
              title={<h2 style={{fontWeight: 'bold'}}>{formatMessage({ id: 'customer.home.your-appointment' }).toUpperCase()}</h2>}
            >
              <Row type="flex" gutter={16} style={{ marginBottom: 20 }}>
                <Col span={24}>
                  <h3>{formatMessage({ id: 'customer.home.yourAppt' })}</h3>
                </Col>
                {appointment.origin === 'WEB' && (
                  <Col span={24}>
                    <Alert type="info" className="branded-border-color branded-color" message={formatMessage({id: 'customer.home.appointmentInfoMessage'})}/>
                  </Col>
                )}
                <Col span={24}>
                  {appointment.startDate && (
                    <Col span={12}>
                      <LabeledText label={formatMessage({id: 'placeholder.startDate'})} text={moment(appointment.startDate).format('DD/MM/YYYY')}/>
                    </Col>
                  )}
                  {appointment.endDate && (
                    <Col span={12}>
                      <LabeledText label={formatMessage({id: 'customer.home.endDate'})} text={moment(appointment.endDate).format('DD/MM/YYYY')}/>
                    </Col>
                  )}
                  {appointment.journey && appointment.journey.type && (
                    <Col span={12}>
                      <LabeledText label={formatMessage({id: 'customer.home.appointmentType'})} text={formatMessage({id: `customer.home.appointmentType.${appointment.journey.type.toLowerCase()}`})}/>
                    </Col>
                  )}
                  {time && (
                    <Col span={12}>
                      <LabeledText label={formatMessage({id: 'label.startTime'})} text={time}/>
                    </Col>
                  )}
                </Col>
              </Row>
              <Row>
                {services && (
                  <DisplaySectionFragment title={formatMessage({id: 'customer.journey.step.summary.chosenService'})}>
                    <N_ServicesSectionFragment
                      selectedOptions={services}
                      selectedTireType={tireReplacement && tireReplacement.tireType}
                      selectedFrontLeftTire={tireReplacement && tireReplacement.positions.frontLeft}
                      selectedFrontRightTire={tireReplacement && tireReplacement.positions.frontRight}
                      selectedBackLeftTire={tireReplacement && tireReplacement.positions.rearLeft}
                      selectedBackRightTire={tireReplacement && tireReplacement.positions.rearRight}
                      selectedTiresBrands={tireReplacement && tireReplacement.brands}
                      tireWidth={tireReplacement && tireReplacement.tireSize && tireReplacement.tireSize.width}
                      tireProfile={tireReplacement && tireReplacement.tireSize && tireReplacement.tireSize.profile}
                      tireDiameter={tireReplacement && tireReplacement.tireSize && tireReplacement.tireSize.diameter}
                      tireExchangeType={tireExchange && tireExchange.type}
                      tireExchangeMode={tireExchange && tireExchange.mode}
                    />
                  </DisplaySectionFragment>
                )}
                {mobilityValue && (
                  <DisplaySectionFragment title={formatMessage({id: 'customer.journey.step.summary.chosenMobility'})}>
                    <ul style={{paddingInlineStart: 0}}>
                      <ItemSectionFragment title={mobilityValue}/>
                    </ul>
                  </DisplaySectionFragment>
                )}
                {receptionText && (
                  <DisplaySectionFragment title={formatMessage({id: 'customer.journey.step.summary.chosenReception'})}>
                    <ul style={{paddingInlineStart: 0}}>
                      <ItemSectionFragment title={formatMessage({id: receptionText})}/>
                    </ul>
                  </DisplaySectionFragment>
                )}
                {address && (
                  <DisplaySectionFragment title={formatMessage({id: 'customer.journey.step.summary.yourAddress'})}>
                    <Address address={{...address}} style={{paddingBottom:'12px', paddingTop:'12px'}}/>
                  </DisplaySectionFragment>
                )}
                {idData && (
                  <DisplaySectionFragment title={formatMessage({id: 'customer.journey.step.summary.yourOfficialInformation'})}>
                    <N_OfficialDocumentSectionFragment
                      formatMessage={formatMessage}
                      licenseId={idData.licenseId}
                      licenseDeliveryDate={idData.deliveryDate}
                      idCardNumber={idData.nationalId}
                      birthDate={idData.birthDate}
                      nationality={idData.nationality}
                      validity={idData.validityDate}
                    />
                  </DisplaySectionFragment>
                )}
              </Row>
            </Card>
          )}
        </Content>
        {frontendConfig.environment && frontendConfig.environment === "PRODUCTION" &&
          <footer style={{paddingLeft: '16px', paddingRight: '16px'}} className="customer-main" tabIndex="-1">
            <Row type="flex" justify="end" align="middle">
              <Col>
                <a style={{color: "black"}} href={frontendConfig[`dsa-${brand}-${host}`][locale]} target="_blank" aria-label={"dsa"}>DSA</a>
              </Col>
            </Row>
          </footer>
        }
      </Layout>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchFetchCustomerData: (params) => dispatch({ type: 'FETCH.CUSTOMER_HOME_DATA.REQUEST', params}),
  openChangeCarModal: () => dispatch({ type: 'CHANGE_CAR_MODAL', changeCarModal: true }),
  openChangeDealerModal: () =>
    dispatch({ type: 'SHOW.CHANGE_DEALER_MODAL', changeDealerModal: true }),
  dispatchFetchMyDealer: params => dispatch({ type: 'FETCH.MY_DEALER.REQUEST', params }),
  dispatchResetSteps: () => dispatch({ type: 'SAVE.RESET_STEPS.REQUEST' }),
  dispatchResetAppointmentRequest: (params) => dispatch({ type: 'SAVE.RESET_APPOINTMENT_REQUEST', params}),
});

const mapStateToProps = state => ({
  dealerLoading: state.dealers.loading,
  vehicleLoading: state.vehicles.loading,
  selectedVehicle: state.customerVehicle.selectedVehicle,
  selectedVIN: state.customerVehicle.selectedVIN,
  selectedDealer: state.customerDealer.selectedDealer,
  selectedDealerLoading: state.customerDealer.loading,
  userDataLoading: state.userData.loading,
  userDataError: state.userData.error,
  userData: state.userData.body,
  publicContext: state.publicContext,
  frontendConfig: state.frontendConfig
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(HomeScreen)
);



// WEBPACK FOOTER //
// ./src/public/HomeScreen.js